import { normalizeLocale, type SupportedLocale } from "@wkt/plugins/i18n";

/** Keep STORAGE_KEY and STARTING_SESSION in sync with public/js/splash-locale.js */
export const SPLASH_LOCALE_STORAGE_KEY = "worktime.client.employee.locale";

const STARTING_SESSION: Record<SupportedLocale, string> = {
  es: "Iniciando sesión",
  en: "Starting session",
  it: "Inizio sessione",
  pt: "Iniciando sessão",
  ro: "Începeți sesiunea",
};

export function persistEmployeeLocale(locale?: string | null): void {
  if (!locale || typeof locale !== "string" || !locale.trim()) {
    return;
  }

  try {
    localStorage.setItem(SPLASH_LOCALE_STORAGE_KEY, normalizeLocale(locale));
  } catch {
    // Ignore quota errors or private browsing restrictions.
  }
}

export function getSplashStartingSessionMessage(
  locale: SupportedLocale,
): string {
  return STARTING_SESSION[locale] ?? STARTING_SESSION.en;
}
